import { gql } from '@parkchirp/api-client';

export const LIST_SURCHARGE_FEES = gql`
  query listSurchargeFees(
    $facilityId: String!,
    $vehicleTypeId: Int!,
  ) {
    listSurchargeFees(
      facilityId: $facilityId,
      vehicleTypeId: $vehicleTypeId
    ) {
      data {
        id
        name
      }
    }
  }
`;
